import { render, staticRenderFns } from "./AccessWalletButton.vue?vue&type=template&id=e6486e48&scoped=true&"
import script from "./AccessWalletButton.vue?vue&type=script&lang=js&"
export * from "./AccessWalletButton.vue?vue&type=script&lang=js&"
import style0 from "./AccessWalletButton.vue?vue&type=style&index=0&id=e6486e48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6486e48",
  null
  
)

export default component.exports